/* oxlint-disable react/forbid-elements -- Original brand illustrations from the approved export. */
import * as React from 'react';
import { cx } from './styles';
import * as media from '../../assets/career/media';
export const CareerFooter: React.FC = () => (
  <footer className={cx('main_section_footer')}>
    <div className={cx('padding-global padding-section-large')}>
      <div className={cx('container-large')}>
        <div className={cx('main_content_footer')}>
          <div className={cx('main_footer_content-grid')}>
            <div className={cx('main_footer_h2-wrapper')}>
              <h2>
                {'будем '}
                <br />
                <span className={cx('text-color-brand-blue')}>
                  {'на '}
                  <br />
                  {'связи'}
                </span>
              </h2>
              <img
                className={cx('main_footer_key-image')}
                src={media.mainFooterKeyImage}
                alt=""
                sizes="100vw"
                loading="lazy"
                srcSet={[media.mainFooterKeyImageP500 + ' 500w', media.mainFooterKeyImage + ' 774w'].join(', ')}
              />
            </div>
            <div className={cx('main_footer_right')}>
              <a
                href="https://t.me/cian_official"
                rel="noopener noreferrer"
                target="_blank"
                className={cx('main_footer_link-item w-inline-block')}
              >
                <div className={cx('main_footer_title-wrapper')}>
                  <img src={media.iconTg} loading="lazy" alt="" className={cx('icon-1x1-medium')} />
                  <div className={cx('heading-style-h3')}>{'Telegram'}</div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  viewBox="0 0 32 26"
                  fill="none"
                  className={cx('icon-1x1-medium text-color-brand-blue')}
                  aria-hidden="true"
                >
                  <path
                    d="M2.04342e-07 12.5711L29.6483 12.5495M18.3533 24.2161L30 12.5495L18.3533 0.882812"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  ></path>
                </svg>
              </a>
              <a
                href="https://vk.ru/cian_official"
                rel="noopener noreferrer"
                target="_blank"
                className={cx('main_footer_link-item w-inline-block')}
              >
                <div className={cx('main_footer_title-wrapper')}>
                  <img src={media.iconVk} loading="lazy" alt="" className={cx('icon-1x1-medium')} />
                  <div className={cx('heading-style-h3')}>{'VK'}</div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  viewBox="0 0 32 26"
                  fill="none"
                  className={cx('icon-1x1-medium text-color-brand-blue')}
                  aria-hidden="true"
                >
                  <path
                    d="M2.04342e-07 12.5711L29.6483 12.5495M18.3533 24.2161L30 12.5495L18.3533 0.882812"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  ></path>
                </svg>
              </a>
              <a
                href="https://career.habr.com/companies/cian-url"
                rel="noopener noreferrer"
                target="_blank"
                className={cx('main_footer_link-item w-inline-block')}
              >
                <div className={cx('main_footer_title-wrapper')}>
                  <img src={media.iconHabr} loading="lazy" alt="" className={cx('icon-1x1-medium')} />
                  <div className={cx('heading-style-h3')}>{'Хабр'}</div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  viewBox="0 0 32 26"
                  fill="none"
                  className={cx('icon-1x1-medium text-color-brand-blue')}
                  aria-hidden="true"
                >
                  <path
                    d="M2.04342e-07 12.5711L29.6483 12.5495M18.3533 24.2161L30 12.5495L18.3533 0.882812"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  ></path>
                </svg>
              </a>
              <a href="mailto:hr@cian.ru" className={cx('main_footer_link-item w-inline-block')}>
                <div className={cx('main_footer_title-wrapper')}>
                  <img src={media.iconEmail} loading="lazy" alt="" className={cx('icon-1x1-medium')} />
                  <div className={cx('heading-style-h3')}>{'Email'}</div>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  viewBox="0 0 32 26"
                  fill="none"
                  className={cx('icon-1x1-medium text-color-brand-blue')}
                  aria-hidden="true"
                >
                  <path
                    d="M2.04342e-07 12.5711L29.6483 12.5495M18.3533 24.2161L30 12.5495L18.3533 0.882812"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
